import axios from "axios";

export const ACTION_FETCH_USER_LIST_PENDING = 'ACTION_FETCH_USER_LIST_PENDING';
export const ACTION_FETCH_USER_LIST_SUCCESS = 'ACTION_FETCH_USER_LIST_SUCCESS';
export const ACTION_FETCH_USER_LIST_ERROR = 'ACTION_FETCH_USER_LIST_ERROR';

function fetchUserListPending() {
    return {
        type: ACTION_FETCH_USER_LIST_PENDING
    }
}

function fetchUserListSuccess(userList) {
    return {
        type: ACTION_FETCH_USER_LIST_SUCCESS,
        userList: userList
    }
}

function fetchUserListError(userListError) {
    return {
        type: ACTION_FETCH_USER_LIST_ERROR,
        userListError: userListError
    }
}

function fetchUserListAction(filter) {
    axios.defaults.baseURL = window.location.origin;
    var url = '/api/User/Search';
    return dispatch => {
        dispatch(fetchUserListPending());
        axios.post(url, filter, { withCredentials: true })
            .then(res => res.data)
            .then(res => {
                dispatch(fetchUserListSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(fetchUserListError(error));
            })
    }
}

export default fetchUserListAction;
